import { render, staticRenderFns } from "./noLive.vue?vue&type=template&id=06709525&scoped=true&"
import script from "./noLive.vue?vue&type=script&lang=js&"
export * from "./noLive.vue?vue&type=script&lang=js&"
import style0 from "./noLive.vue?vue&type=style&index=0&id=06709525&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06709525",
  null
  
)

export default component.exports